/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AccountRelationship {
  CurrentlyEngaged = "CurrentlyEngaged",
  PreviouslyEngaged = "PreviouslyEngaged",
  PreviouslyInterviewing = "PreviouslyInterviewing",
  PreviouslySubmitted = "PreviouslySubmitted",
  PreviouslyEmployed = "PreviouslyEmployed",
}

export const AccountRelationshipDisplay: Record<AccountRelationship, string> = {
  [AccountRelationship.CurrentlyEngaged]: "Currently Engaged",
  [AccountRelationship.PreviouslyEngaged]: "Previously Engaged",
  [AccountRelationship.PreviouslyInterviewing]: "Previously Interviewing",
  [AccountRelationship.PreviouslySubmitted]: "Previously Submitted",
  [AccountRelationship.PreviouslyEmployed]: "Previously Employed",
};
